(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_built--cv-shop-by-shade--shade"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// node_modules/requestidlecallback-polyfill/index.js
		window.requestIdleCallback = window.requestIdleCallback || function(cb) {
			var start = Date.now();
			return setTimeout(function() {
				cb({
					didTimeout: false,
					timeRemaining: function() {
						return Math.max(0, 50 - (Date.now() - start));
					}
				});
			}, 1);
		};
		window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
			clearTimeout(id);
		};

		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}

		// src/utilities/localizedPath.ts
		function localizedPath(path) {
			const root = (window.Shopify?.routes?.root ?? "/").replace(/\/$/, "");
			if (!root || !path.startsWith("/") || path.startsWith("//")) return path;
			const url = new URL(path, window.location.origin);
			if (url.pathname === root || url.pathname.startsWith(`${root}/`)) return path;
			url.pathname = root + url.pathname;
			return url.pathname + url.search + url.hash;
		}

		// src/utilities/fetchSection.ts
		async function fetchSection(sectionId, {
			params = {},
			path = window.location.pathname,
			signal
		} = {}) {
			const url = new URL(localizedPath(path), window.location.origin);
			url.search = String(
				new URLSearchParams({ section_id: sectionId, ...params })
			);
			const response = await fetch(url, { signal });
			if (!response.ok) {
				throw new Error(
					`fetchSection: HTTP ${response.status} ${response.statusText}`
				);
			}
			const parsed = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			);
			return parsed.querySelector('[id^="shopify-section-"]') ?? parsed.body;
		}

		// src/blocks/cv-shop-by-shade/blocks/shade/shade.ts
		var CARDS_SECTION_ID = "built--cv-shop-by-shade--shades";
		var INTERACTION_EVENTS = ["pointerenter", "focusin", "touchstart"];
		var Shade = class extends HTMLElement {
			abort;
			loaded = false;
			connectedCallback() {
				if (this.deferredCount() > 0) this.setupDeferredLoad();
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			deferredCount() {
				const count = Number(this.dataset.limit);
				return Number.isFinite(count) ? count : 0;
			}
			setupDeferredLoad() {
				this.abort = new AbortController();
				const { signal } = this.abort;
				const load = () => this.loadDeferred();
				scheduleIdle(load, signal);
				INTERACTION_EVENTS.forEach((event) => {
					this.addEventListener(event, load, { signal, passive: true });
				});
			}
			async loadDeferred() {
				if (this.loaded || !this.abort) return;
				this.loaded = true;
				const { signal } = this.abort;
				const track = requireElement(".cv-stack", this);
				try {
					const cards = await this.fetchCards(signal);
					track.append(...cards);
				} catch (error) {
					if (signal.aborted) return;
					console.error("[cv-shop-by-shade] deferred load failed:", error);
				} finally {
					this.abort?.abort();
				}
			}
			async fetchCards(signal) {
				const handle = this.dataset.collectionHandle;
				if (!handle) throw new Error("missing data-collection-handle");
				const section = await fetchSection(CARDS_SECTION_ID, {
					path: `/collections/${encodeURIComponent(handle)}`,
					params: {
						offset: this.dataset.offset ?? "0",
						limit: this.dataset.limit ?? "0"
					},
					signal
				});
				return Array.from(section.querySelectorAll(":scope > li"));
			}
		};
		function scheduleIdle(callback, signal) {
			if (signal.aborted) return;
			const handle = window.requestIdleCallback(callback);
			signal.addEventListener("abort", () => window.cancelIdleCallback(handle), {
				once: true
			});
		}
		if (!customElements.get("cv-shade")) {
			customElements.define("cv-shade", Shade);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["built--cv-shop-by-shade"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}

		// src/blocks/cv-shop-by-shade/cv-shop-by-shade.ts
		var TAB_SELECTOR = '[role="tab"]';
		var SWATCH_SELECTOR = ":scope cv-shade-label";
		var tabCount = 0;
		var ShopByShade = class extends HTMLElement {
			abort;
			container;
			connectedCallback() {
				const abort = new AbortController();
				this.abort = abort;
				const container = this.container ?? this.build();
				container.addEventListener(
					"click",
					(event) => {
						this.handleClick(event);
					},
					{
						signal: abort.signal
					}
				);
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			build() {
				const container = document.createElement("div");
				container.setAttribute("role", "tablist");
				container.className = "cv-shop-by-shade__swatch-selector";
				this.container = container;
				this.shades.forEach((shade) => {
					const shadeButton = this.createShadePanel(shade);
					if (shadeButton instanceof Element) {
						container.appendChild(shadeButton);
					}
				});
				const firstShade = container.querySelector(TAB_SELECTOR);
				if (firstShade) this.select(firstShade);
				const shadeSelectorContainer = requireElement(
					".cv-shop-by-shade__swatch-selector-container",
					document
				);
				shadeSelectorContainer.appendChild(container);
				this.classList.add("cv-shop-by-shade--ready");
				return container;
			}
			select(tab) {
				const panelId = tab.getAttribute("aria-controls");
				this.tabs.forEach((candidate) => {
					const selected = candidate === tab;
					candidate.setAttribute("aria-selected", String(selected));
					candidate.tabIndex = selected ? 0 : -1;
				});
				this.shades.forEach((shade) => {
					shade.toggleAttribute("hidden", shade.id !== panelId);
				});
			}
			handleClick(event) {
				if (!(event.target instanceof Element)) return;
				const shade = event.target.closest(TAB_SELECTOR);
				if (!shade) return;
				this.select(shade);
				shade.focus();
			}
			get shades() {
				return Array.from(this.querySelectorAll(":scope > cv-shade"));
			}
			get tabs() {
				return Array.from(
					this.container?.querySelectorAll(TAB_SELECTOR) ?? []
				);
			}
			createShadePanel(shade) {
				const swatch = shade.querySelector(SWATCH_SELECTOR);
				if (!swatch) return;
				const id = tabCount++;
				const tabId = `cv-shade-label-${id}`;
				const panelId = `cv-shade-content-${id}`;
				shade.setAttribute("role", "tabpanel");
				shade.id = panelId;
				shade.setAttribute("aria-labelledby", tabId);
				shade.tabIndex = 0;
				const button = document.createElement("button");
				button.className = "cv-shade__swatch-button";
				button.type = "button";
				button.id = tabId;
				button.setAttribute("role", "tab");
				button.setAttribute("aria-controls", panelId);
				button.appendChild(swatch);
				return button;
			}
		};
		if (!customElements.get("cv-shop-by-shade")) {
			customElements.define("cv-shop-by-shade", ShopByShade);
		}
	})();
  } catch(e) { console.error(e); }
})();

})();
